import axiosInstance from "./axiosConfig";

/**
 * Generate blog content with AI
 * @param {Object} data - { topic, audience, goal, tone, length, keywords, notes }
 */
export const generateBlogApi = async (data) => {
    return await axiosInstance.post("/blog/generate/", data);
};

/**
 * Search for images on Pixabay
 * @param {Object} data - { keyword, count }
 */
export const searchImagesApi = async (data) => {
    return await axiosInstance.post("/blog/search-images/", data);
};

/**
 * Create an ActionQueue entry for WordPress publishing
 * @param {Object} data - { project_id, action_type: "create_blog_post", payload: { ... } }
 */
export const createBlogActionApi = async (data) => {
    return await axiosInstance.post("/blog/create-action/", data);
};

/**
 * Check the status of a blog action
 * @param {number|string} actionId - The ID of the action to check
 */
export const getBlogStatusApi = async (actionId) => {
    return await axiosInstance.get(`/blog/status/${actionId}/`);
};